import { render, staticRenderFns } from "./TrainingSettings.vue?vue&type=template&id=3bd21df2&scoped=true"
import script from "./TrainingSettings.vue?vue&type=script&lang=js"
export * from "./TrainingSettings.vue?vue&type=script&lang=js"
import style0 from "./TrainingSettings.vue?vue&type=style&index=0&id=3bd21df2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd21df2",
  null
  
)

export default component.exports